export default __webpack_public_path__ + "static/media/business-problem4.0a6b7b4c.png";